import { render, staticRenderFns } from "./page3.vue?vue&type=template&id=2eaaf384&scoped=true&"
import script from "./page3.vue?vue&type=script&lang=js&"
export * from "./page3.vue?vue&type=script&lang=js&"
import style0 from "./page3.vue?vue&type=style&index=0&id=2eaaf384&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eaaf384",
  null
  
)

export default component.exports